import type { ISvgProps } from './types';

export function DefaultLogoSvg({ size = 48, className }: ISvgProps) {
  return (
    <svg
      height={size}
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 193.94 63.56"
      className={className}
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M169.69,18.88V2.3c0-1.27-1.03-2.3-2.31-2.3h-74.17c-1.27,0-2.31,1.03-2.31,2.3v16.58c0,1.27-1.03,2.3-2.31,2.3h-10.54c-1.28,0-2.31-1.03-2.31-2.3V2.3c0-1.27-1.03-2.3-2.31-2.3H2.31C1.03,0,0,1.03,0,2.3v37.76c0,1.27,1.03,2.3,2.31,2.3h19.63c1.28,0,2.31,1.03,2.31,2.3v16.58c0,1.27,1.03,2.3,2.31,2.3h74.17c1.28,0,2.31-1.03,2.31-2.3v-16.58c0-1.27,1.03-2.3,2.31-2.3h10.54c1.28,0,2.31,1.03,2.31,2.3v16.58c0,1.27,1.03,2.3,2.31,2.3h71.14c1.28,0,2.31-1.03,2.31-2.3V23.49c0-1.27-1.03-2.3-2.31-2.3h-19.63c-1.28,0-2.31-1.03-2.31-2.3h0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
